// 用途 (purpose) catalog — colors mirror the user's Excel color-coding.
export const PURPOSES = [
  { label: '事務所', color: '#7030A0' },
  { label: '資材', color: '#002060' },
  { label: 'ヒーター', color: '#0070C0' },
  { label: 'センスビー', color: '#00B050' },
  { label: 'ソルダリング', color: '#92D050' },
  { label: '技術課', color: '#4A5D23' },
  { label: 'Pi Server', color: '#ED7D31' },
  { label: 'プリントサーバー', color: '#EAB308' },
  { label: 'スイッチ＆WIFI', color: '#F59E0B' },
  { label: 'サーバー', color: '#EF4444' },
];

const COLOR_MAP = Object.fromEntries(PURPOSES.map((p) => [p.label, p.color]));

export const purposeColor = (label) => COLOR_MAP[label] || '#cbd5e1';

export function hexToRgba(hex, a) {
  const h = (hex || '#cbd5e1').replace('#', '');
  const n = parseInt(h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
}

export function contrastText(hex) {
  const h = (hex || '#cbd5e1').replace('#', '');
  const n = parseInt(h, 16);
  const lum = 0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255);
  return lum > 150 ? '#1f2937' : '#ffffff';
}
